// extracted by mini-css-extract-plugin
export var attachment = "_nx-a";
export var emailContainer = "_nx-4";
export var emailContentPaddedContainer = "_nx-b";
export var emailHeader = "_nx-6";
export var emailIframe = "_nx-3";
export var emailInfoIcon = "_nx-9";
export var emailShortenedSummary = "_nx-e";
export var infoDropdown = "_nx-0";
export var infoRowBoundedContent = "_nx-d";
export var internal = "_nx-5";
export var merchant = "_nx-8";
export var messageInputContainer = "_nx-h";
export var normal = "_nx-7";
export var replyCard = "_nx-f";
export var subtleButton = "_nx-1";
export var subtleButtonIconContainer = "_nx-2";
export var toggleViewRepliesButton = "_nx-c";
export var wrappingText = "_nx-g";